class Navigation {

    init() {
        this.navBtn = document.querySelector('.nav-btn');
        this.navBtn.addEventListener('click', this.toggleNav.bind(this));
    }

    toggleNav() {

        let body = document.body;
        body.classList.toggle('nav-is-active');
    }
}

export default new Navigation();